module.exports = __webpack_public_path__ + "img/sofyre-ingredients.6c66f9fb.png";